import TornadoChart from "../charts/TornadoChart";
import PropTypes from "prop-types";
import { benchmarkCategories } from "../estimates/EstimatesBenchmarkDonutComponent.functions";
import { AVERAGE } from "../../actions/types";

import { tranStr } from "../../utils/translation";

import "./BenchmarkingHeatmapTornado.css";

BenchmarkingHeatmapTornado.propTypes = {
  thisBenchmark: PropTypes.any,
  benchmarks: PropTypes.any,
  caller: PropTypes.any,
  unitOfMeasure: PropTypes.any,
};

export function BenchmarkingHeatmapTornado(props) {
  const { thisBenchmark, benchmarks } = props;
  const { caller } = props;
  const { unitOfMeasure } = props;

  if (caller !== "COST_PLAN_BENCHMARKING") {
    return null;
  }

  const estimateCategories = benchmarkCategories(
    [thisBenchmark],
    "Element Categories",
    AVERAGE
  );
  const comparisonCategories = benchmarkCategories(
    benchmarks,
    "Element Categories",
    AVERAGE
  );

  const labels = [];
  const dataset1 = [];
  const dataset1Label = "Cost per m² GIA - Project";
  const dataset2 = [];
  const dataset2Label = "Cost per m² GIA - Average";

  estimateCategories.forEach((ec) => {
    const label = ec.name;
    const subjectProject = ec.quantity;

    labels.push(label);
    dataset1.push(subjectProject * -1); // Left of the Tornado Graph
  });

  comparisonCategories.forEach((ec) => {
    const average = ec.quantity;

    dataset2.push(average); // Right of the Tornado Graph
  });

  return (
    <div className="benchmarking-heatmap-tornado">
      <h1
        className="display-4"
        style={{
          fontSize: "20px",
          marginBottom: "20px",
          marginTop: "10px",
          marginLeft: "10px",
        }}
      >
        {tranStr("Project Comparison vs Benchmark Average Construction Costs")}
      </h1>
      <TornadoChart
        originalLabels={labels}
        dataset1={dataset1}
        dataset2={dataset2}
        dataset1Label={dataset1Label}
        dataset2Label={dataset2Label}
        unit={unitOfMeasure}
      />
    </div>
  );
}
